<template>
  <div class="mainPart">
    <el-form :model="settingForm" inline class="searchForm">
      <el-form-item label="闪核工作时段">
        <el-time-picker is-range v-model="settingForm.worktime" range-separator="至" :picker-options="{selectableRange: '00:00 - 23:59'}" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围" format="HH:mm" value-format="HH:mm" clearable :disabled="cannotedit" popper-class="timeBox"></el-time-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="setScanCodesTime(1)">{{cannotedit?'修改':'保存'}}</el-button>
        <el-button type="primary" plain @click="setScanCodesTime(0)" v-show="!cannotedit">取消</el-button>
        <el-button type="success" plain @click="updateStatus('',1,1)">一键上线</el-button>
        <el-button type="danger" plain @click="updateStatus('',0,1)">一键离线</el-button>
      </el-form-item>
    </el-form>
    <el-table class="comTable" ref="codeTable" :data="codeScannerData" border :max-height="tableHeight" v-loading="vloading">
      <el-table-column label="序号" type="index" width="60"></el-table-column>
      <el-table-column label="设备编号" min-width="300">
          <template slot-scope="scope">
            <p :title="scope.row.machinecode">
              <!-- <el-tag type="danger" plain v-if="scope.row.status == 0">已禁用</el-tag> -->
              {{ scope.row.machinecode}}
            </p>
          </template>
      </el-table-column>
      <el-table-column label="设备状态" prop="onlinestatus" sortable  min-width="300">
          <template slot-scope="scope">
            <el-switch :width="55" class="isSwitch" :value="scope.row.onlinestatus ? true :false" @change="updateStatus(scope.row.cscodes,scope.row.onlinestatus,0)" :active-text="scope.row.onlinestatus?'在线':'离线'"></el-switch>
          </template>
      </el-table-column>
      <template slot="empty">
        <div class="noData"><span>暂无数据</span></div>
      </template>
    </el-table>
    <!-- S 分页 -->
    <!-- <Page
      :pageTotal="page.pagetotal"
      :currentPage="page.currentpage"
      :pageSize="page.pagesize"
      v-on:nowPageParam="nowPageParam"
    ></Page> -->
    <!-- S 分页 -->
  </div>
</template>
<script>
import api from '../../apis/api';

export default {
  name: "CodeScannerSetting",
  data() {
    return {
      cannotedit:true,
      settingForm:{
        worktime: ['00:00', '23:59'],
      },
      vloading:false,
      // page: {
      //   pagetotal: 0,
      //   pagesize: 30,
      //   currentpage: 1,
      //   isnewcomp: 1,
      //   sortparam: null,
      //   sorttype: 0
      // },
      flowcode:'', // 流向方编号
      codeScannerData:[], // 扫码仪列表
      tableHeight: window.innerHeight*.8, //表格动态高度
    };
  },
  watch: {},
  components: {
    // Page: resolve => require(["@/components/common/Page.vue"], resolve)
  },
  methods: {
    // 更改扫码仪状态
    updateStatus(cscodes,onlinestatus,type){
      let valTxt = '';
      let status = 0;
      if(type==1){ //一键在线/离线
        status = onlinestatus;
        valTxt = onlinestatus?'上线当前门店所有设备？':'离线当前门店所有设备？'
      }else{
        if(!onlinestatus){
          valTxt = '确定要将该设备上线吗？';
          status = 1;
        }else{
            valTxt = '确定要将该设备离线吗？';
            status = 0;
        }
      }
      this.$confirm(valTxt, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
          let params = {
              cscodes:cscodes,
              onlinestatus:status,
              flowcode:this.flowcode
          }
          api.UPDATEONLINESTATUS(params).then((res) => {
              if(res.data.status == '200'){
                  this.$message.success(res.data.message);
                  this.CatCodesScanList() // 刷新列表
              }else{
                  this.$message.error(res.data.message);
              }
          }).catch(()=>{})
      }).catch(() => {});
    },
    // nowPageParam(pageSize, currentPage) {
    //   this.page.currentpage = currentPage;
    //   this.page.pagesize = pageSize;
    //   //   this.CatCodesScanList() // 刷新列表
    // },
    /**
     * 描述 设置扫码仪工作时间时，处理时间
     * @date 2023-02-14
     * @param {any} array
     * @param {any} cut
     * @returns {any}
     */
    DealWithTime(array,type){
      if(type){
        // 格式化时间传参 ['08:30', '18:00'] --> '8:30#18:00'
        if(array!=null){
          let tmparray = array.map(item => {
            const tmplist = item.split(':');
            const result = Number(tmplist[0]).toString() + ':' + tmplist[1]
            return result
          });
          return tmparray.join('#')
        }else {
          return ''
        }
      }else {
        if(array!=null){
          // 转换格式'8:30#18:00' --> ['08:30', '18:00'] 用于映射时间选择器参数
          let tmpArray = array.split('#') // ['8:30','18:00']
          let tmpResult = tmpArray.map(item=>{
            const tempArr = item.split(':');
            const result = (Number(tempArr[0])<10?('0'+Number(tempArr[0]).toString()):(Number(tempArr[0]).toString())) + ':' + tempArr[1]
            return result
          })
          return tmpResult
        }else {
          return ['00:00','23:59']
        }
      }
    },
    // 查询扫码仪列表
    CatCodesScanList(){
      api.GETCODESCANNERLIST({flowcode:this.flowcode}).then(res=>{
        if (res.data.status == "200" && res.data.data) {
          this.codeScannerData = res.data.data
          const tmpWorkTime = res.data.data[0].worktime
          this.settingForm.worktime = this.DealWithTime(tmpWorkTime,false)
          console.log('this.settingForm.workTime', this.settingForm.worktime)
        }else{
          this.$message.error(res.data.message)
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    // 设置扫码仪工作时间
    setScanCodesTime(val){
      this.cannotedit = !this.cannotedit
      console.log('this.cannotedit1', this.cannotedit)
      if(val){
        if(this.cannotedit){
        const params = { "worktime": this.DealWithTime(this.settingForm.worktime,true), flowcode:this.flowcode }
        api.SETSCANCODESTIME(params).then(res=>{
            if(res.data.status == "200") {
              this.$message.success(res.data.message)
              this.CatCodesScanList() // 刷新列表
            }else {
              this.$message.error(res.data.message)
            }
          }).catch(()=>{})
        }
      }
    },
    //动态获取表格高度
    getHeight() {
      let tbHeight = this.$refs.codeTable.$el.offsetTop; //顶部检索条件占据的高度
      this.tableHeight = window.innerHeight - tbHeight - 120;
    },
  },
  created() {
    //页面浏览器视窗变化绑定resize事件
    window.addEventListener("resize", this.getHeight);
  },
  mounted() {
    if(localStorage.getItem('userInfoMd')&&localStorage.getItem('userInfoMd')!=undefined) {
        let mdInfo = JSON.parse(localStorage.getItem('userInfoMd'));
        this.flowcode = mdInfo.flowcode;
    };
    this.CatCodesScanList() // 刷新列表
    setTimeout(()=>{
      this.getHeight();
    },200);
  },
  destroyed(){
    window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
  }
};
</script>

<style scoped>
.mainPart { padding: 20px; height: calc(100% - 50px);}
</style>



// WEBPACK FOOTER //
// src/views/ManageFolder/CodeScannerSetting.vue